import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ResearchManagementService } from './research-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-research-management',
  templateUrl: './research-management.component.html',
  styleUrls: ['./research-management.component.scss']
})
export class ResearchManagementComponent implements OnInit {
  allResearch;
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number;
  rows: any[];
  search: string;
  isSearch: boolean = false;
  searchResearch: any = '';

  sortIdFn = (a, b) => a.RESEARCH_ID.localeCompare(b.RESEARCH_ID);
  viewStatusFilterFn = (list: string[], item) => list.some(status => item.IS_VIEW === status);

  filterViewStatus = [
    { text: 'เปิด', value: 0 },
    { text: 'ปิด', value: 1 }
  ];

  constructor(
    public matDialog: MatDialog,
    private researchManagementService: ResearchManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('การจัดการวิจัย');
    this.getAllResearch();
  }

  getAllResearch() {
    this.researchManagementService.getAllResearch().pipe(
      map(res => {
        this.allResearch = res.result;
        for (let i = 0; i < this.allResearch.length; i++) {
          this.allResearch[i].MEASURES = [...this.allResearch[i].MEASURES];
        }
        // console.log(this.allResearch);
        // console.log(JSON.parse(this.allResearch[0].VALUE));
      })
    ).subscribe();
  }

  addResearch() {
    window.open('/research-management/manage-research?isEdit=false', '_blank');
  }

  viewDetail(researchId) {
    window.open('/research-management/manage-research?isEdit=true&research_id=' + researchId, '_blank');
  }

  changeStatus(event, research) {
    const dialogConfig = new MatDialogConfig();
    let body;

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';

    if (research.IS_VIEW) {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการเปิดสถานะการมองเห็น ผู้ใช้จะสามารถเห็นวิจัยได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        RESEARCH_ID: research.RESEARCH_ID,
        IS_VIEW: 0
      }
    } else {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการปิดสถานะการมองเห็น ผู้ใช้จะไม่สามารถเห็นวิจัยได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        RESEARCH_ID: research.RESEARCH_ID,
        IS_VIEW: 1
      }
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res) {
        this.researchManagementService.updateStatusViewResearchById(body).pipe(
          map((res2) => {
            event.source.checked = research.IS_VIEW;
            this.getAllResearch();
          })
        ).subscribe();
      } else {
        event.source.checked = !research.IS_VIEW;
      }
    })
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchResearch = [];
      this.allResearch.filter(research => {
        if (research.RESEARCH_NAME.toLowerCase().includes(this.search.toLowerCase()) || research.CREATE_NAME.toLowerCase().includes(this.search.toLowerCase()) || research.MEASURES.toString().toLowerCase().includes(this.search.toLowerCase())) {
          this.searchResearch.push(research)
        }
      });
    } else {
      this.isSearch = false
      this.searchResearch = null;
      this.getAllResearch();
    }
  }

  exportFile(id, name) {
    const body = {
      RESEARCH_ID: id
    }

    this.researchManagementService.exportResearchById(body).pipe(
      map(res => {
        // console.log(res.result);
        const _data = [];
        let _value = [];
        res.result.map((d) => {
          // console.log(d.DATAS)
          d.DATAS.map(res => {
            Object.keys(res).map((v, i) => {
              _value[v] = Object.values(res)[i];
            })
          })
          // // console.log(_value);

          _data.push({
            USER_ID: d.USER_ID,
            ...d.DATA_SCRENE,
            ..._value,
          })
        })

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(_data);
        const workbook: XLSX.WorkBook = {
          Sheets: { Sheet1: worksheet },
          SheetNames: ['Sheet1'],
        };

        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });

        const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

        FileSaver.saveAs(data, `${name.replace(/\./g, ' ')}_ ${new Date().toISOString().substring(0, 10)}`);
      })
    ).subscribe();
  }
}
